<template>
  <section class="chat-view">
    <section class="conversation-title">
      <h1 class="title has-text-centered is-size-4">{{ $t('projectPage.teamChatTitle') }}</h1>
      <h2 class="subtitle is-size-6 pt-2 has-text-centered">{{ $t('projectPage.teamChatSubtitle') }}</h2>
    </section>
    <section v-if="!hasConversation" class="start-container is-flex">
      <button class="start-button button is-primary is-uppercase has-text-weight-bold" @click="createProjectConversation">
        <i class="message-icon fal fa-comments-alt"></i>
        {{ $t('projectPage.startNewConversation') }}
      </button>
    </section>
    <section v-if="hasConversation" class="conversation-area">
      <messages v-if="conversationMessages.length > 0" ref="messages" class="message-area"
        :conversation="conversation" :users="conversationUsers" :chatType="chatType" v-on:showModal="seenDeleteModal = true, idToDelete = $event">
      </messages>
      <add-message ref="addMessage" :chatType="chatType" :conversation="conversation" @scrollToBottom="scrollToBottom()"></add-message>
    </section>
    <modal-custom v-if="seenDeleteModal" :title="'Delete Message'"
                  :text="'Are you sure you want to delete this message?'"
                  :hasFooter="true" :successText="'Delete'" :cancelText="'Cancel'"
                  @modalSuccess="deleteMessage(idToDelete)" @modalCancel="seenDeleteModal = false">
    </modal-custom>
  </section>
</template>

<script>
import state from '../state'

import Messages from '@/components/Pages/Messaging/Messages'
import ModalCustom from '@/components/Modals/Custom'

import AddMessage from '@/components/Inputs/AddMessage'
import addMessageMixin from '@/components/Inputs/AddMessage/addMessageMixin'

import auth from '@/mixins/auth'
import componentState from '@/mixins/component-state'

export default {
  props: ['stateKeyValue'],
  components: {
    Messages,
    AddMessage,
    ModalCustom
  },
  mixins: [auth, componentState, addMessageMixin],
  data: function () {
    return {
      conversation: null,
      chatType: 'TeamChat'
    }
  },
  watch: {
    stateKeyValue: function (value) {
      this._setObjectKey(value)
    },
    project: function () {
      this.getProjectConversation()
    },
    chatType: function () {
      this.getProjectConversation()
    }
  },
  computed: {
    hasConversation: function () {
      return this.conversation !== null
    },
    project: function () {
      return this._get(state.project.id) ? this.$store.getters.project(this._get(state.project.id)) || {} : {}
    },
    conversationUsers: function () {
      return this.conversation?.users ? this.conversation.users : []
    },
    conversationMessages: function () {
      return this.conversation?.messages ? this.conversation.messages : []
    }
  },
  methods: {
    getProjectConversation: function () {
      if (!this.project) {
        return
      }
      this.$store.dispatch('getChatConversation', { projectID: this.project.id, chatType: this.chatType }).then((projectConversation) => {
        this.conversation = projectConversation
        if (this.conversation && this.conversation.unread) {
          this.$store.dispatch('markConversationRead', this.conversation)
        }
      })
    },
    createProjectConversation: function () {
      this.$store.dispatch('createChatConversation', { projectID: this.project.id, chatType: this.chatType }).then((projectConversation) => {
        this.conversation = projectConversation
      })
    }
  }
}

</script>

<style lang="scss" scoped>
  @import '~styles/utils.scss';

.chat-view {
  width: 100%;
  .conversation-title {
    border-bottom: 1px solid whitesmoke;
    padding: 1rem 0;
  }
  .start-container {
    width: 100%;
    justify-content: space-around;
    .start-button {
      margin: 2rem auto;
      font-size: 0.65rem;
      border-radius: 0;
      .message-icon {
        padding-top: 0.1rem;
        font-size: 0.9rem;
        margin-right: 0.5rem;
      }
    }
  }
}
.conversation-area {
  height: 100%;
  background-color: #f2f2f2;
  .message-area {
    max-height: 450px;
  }
}
</style>
